import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { groupByMonth, getLimitDate, getDateLabels, countList, sumList, firstYear, yearsListOption } from '../../utils/statsFunctions';

import HighChartStack from './Charts/HighChartStack';
import { Card, Grid, Box, Divider, ListItem, ListItemText, Typography, ListItemSecondaryAction, List, ButtonGroup, Button } from '@mui/material';
import { InputSelectNative } from '../common/Form';
import { hex2rgba } from '../Admin/Budget/BudgetSingle';
import Currency from '../common/Currency';
import { COLORS } from '../common/ColorPicker';
import { getLabelsCustom } from './statsFunctions';


class StackedStatsIn extends Component {
    state = { 
        year: this.props.budget_year || new Date().getFullYear(),
    }

    filterList = () => {
        const { INCOMES, filter_payment, fieldBy } = this.props;
  
        let list = Object.values(INCOMES)
        if ( filter_payment && filter_payment !== "all" ) {
			list = this.filterPayment(list, filter_payment)
		}

        let nbPerCatlist = countList(list, fieldBy)
        let topCats = Object.keys(nbPerCatlist).sort( (a, b) => nbPerCatlist[b] - nbPerCatlist[a])

        return {list, topCats}
    }

    filterPayment = (list, filter_payment) => {
		let fully_paid = filter_payment === "spent" ? true : false; 

		let filteredList = list.filter( income => 
			income.income_spent === fully_paid 
		)

		return filteredList
	}

    calcData = () => {
        const { POSTS, BANKS, start_date, end_date, fieldBy, fieldName } = this.props;
        let LIST = fieldBy === "income_post" ? POSTS : BANKS
        let sum = {}
        let series = []
        let bckg = []
        let average = []
        let formatted = {}
        let total = 0

        let info = this.filterList()
        
        let list = info.list
        let postList = info.topCats
        let dateLabels = getLabelsCustom(start_date, end_date)
        let categories = groupByMonth(list, "income_date")
        // let categories = this.props.filter_period === "year" ? groupByMonth(list, "income_date") : groupByDate(list, "income_date")

        dateLabels.forEach( date => {
            sum[date] = categories[date] ? sumList(categories[date], fieldBy, "income_amount") : {}
        })
        
        postList.forEach(post => {
            Object.values(sum).forEach( data => {
                if(!formatted[post]){
                    formatted[post] = []
                }
                formatted[post].push(data[post] || 0)
            })
        })
        Object.keys(formatted).forEach( (itemID, i) => {
            series.push({
                name: !isEmpty(LIST) && LIST[itemID] && 
                    `${LIST[itemID][fieldName]}`,
                data: formatted[itemID],
            })

            total += formatted[itemID].reduce((prev, curr) => prev + curr )
            bckg.push(COLORS[i*2])
        })
            
 
        console.log('====================================');
        console.log({categories, series, bckg, sum, formatted, list});
        console.log('====================================');
        return {categories : dateLabels, series, bckg, total}
    }

    render() {
        const { INCOMES, POSTS, BANKS, noDateFilter, fieldBy } = this.props;
        let LIST = fieldBy === "income_post" ? Object.assign({}, POSTS) : Object.assign({}, BANKS)
        let info_stack = !isEmpty(INCOMES) && !isEmpty(LIST) ? this.calcData() : {}
        
        return (
            <Box>
                <Box style={{display:'flex', justifyContent: 'space-between'}}>
                    <Box>
                        {this.props.general &&
                            <ButtonGroup color="secondary" disableElevation size="small">
                                <Button
                                    onClick={() => this.props.changeFieldBy("income_post", "post_name")}
                                    variant={this.props.fieldBy === "income_post" ? "contained" : "outlined"} 
                                >
                                    Postes
                                </Button>
                                <Button
                                    onClick={() => this.props.changeFieldBy("income_bank", "bank_name")}
                                    variant={this.props.fieldBy === "income_bank" ? "contained" : "outlined"} 
                                >
                                    Banques
                                </Button>
                            </ButtonGroup>
                        }
                    </Box>

					<Box style={{display:'flex', justifyContent: 'space-between'}}>
                        <Typography style={{paddingRight: "20px"}}>Total </Typography>
                        <Typography color="primary" > <Currency value={info_stack.total} /></Typography>
                    </Box>
                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box p={2}>
                            {/* {!noDateFilter &&
                                <InputSelectNative
                                    labelWidth={60}
                                    onChange={ (e) => this.setState({ year: e.target.value })}
                                    value={this.state.year}
                                    label="Année"
                                    options={yearsListOption()}
                                    // options={[
                                    //     <option>{new Date().getFullYear()}</option>,
                                    //     <option>{firstYear}</option>
                                    // ]}
                                />
                            } */}
                        </Box>
                        <Card>
                            <HighChartStack 
                                title={this.props.fieldBy === "income_bank" ? "Recettes par Banques" : "Recettes par Postes"}
                                titleY="Montant FCFA"
                                type="column"
                                categories={info_stack.categories}
                                series={info_stack.series}
                                legend={false}
                                colors={info_stack.bckg}
                            />
                            
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

export default StackedStatsIn;

